<template>
  <TransitionBounceComponent>
    <ProjectsTourComponent v-if="showTour && isTourPending" />
  </TransitionBounceComponent>
</template>

<script>
import TransitionBounceComponent from "@/components/Transitions/Bounce";
import ProjectsTourComponent from "./Tour";

export default {
  name: "WrapperProjectsTourComponent",
  data() {
    return {
      showTour: false
    };
  },
  computed: {
    isTourPending() {
      const { user_config_general } = this.$store.getters.getUser;
      return (
        user_config_general && !user_config_general.is_projects_tour_completed
      );
    }
  },
  components: {
    TransitionBounceComponent,
    ProjectsTourComponent
  },
  mounted() {
    setTimeout(() => {
      if (this.isTourPending) this.showTour = true;
    }, 1000);
  }
};
</script>

<style lang="scss" scoped></style>
